/**
 * Dropdown
 */

export default function initDropdown(){
	const dropdowns = document.querySelectorAll('.dropdown');

	dropdowns.forEach((dropdown) => {
		const toggle = dropdown.querySelector('.dropdown__toggle');
		const list = dropdown.querySelector('.dropdown__list');
		const items = dropdown.querySelectorAll('.dropdown__item a');

		let isOpen = false;

		const toggleMenu = (open) => {
			isOpen = open;
			toggle.setAttribute('aria-expanded', isOpen);
			list.setAttribute('aria-hidden', !isOpen);

			if ( isOpen ){
				list.focus();
			}
		};

		toggle.addEventListener('click', () => {
			// Close all other dropdowns
			dropdowns.forEach((otherDropdown) => {
				if ( otherDropdown!==dropdown ){
					const otherMenu = otherDropdown.querySelector('.dropdown__list');
					const otherToggle = otherDropdown.querySelector('.dropdown__toggle');
					otherToggle.setAttribute('aria-expanded', false);
					otherMenu.setAttribute('aria-hidden', true);
				}
			});

			toggleMenu(!isOpen);
		});

		toggle.addEventListener('keydown', (e) => {
			if ( e.key==='ArrowDown' ){
				e.preventDefault();

				toggleMenu(true);
				items[0 ].focus();
			}
		});
	
		list.addEventListener('keydown', (e) => {
			const focusedIndex = Array.from(items).indexOf(document.activeElement);

			if ( e.key==='ArrowDown' ){
				e.preventDefault();
				items[(focusedIndex + 1) % items.length].focus();

			} else if ( e.key==='ArrowUp' ){
				e.preventDefault();
				items[(focusedIndex - 1 + items.length) % items.length].focus();

			} else if ( e.key==='Escape' ){
				e.preventDefault();
				toggleMenu(false);
				toggle.focus();

			}
		});

		items.forEach((item) => {
			item.addEventListener('click', () => {
				toggleMenu(false);
				//toggle.textContent = item.textContent; // Optionally update the button label
			});
		});

		document.addEventListener('click', (e) => {
			if ( !dropdown.contains(e.target) ){
				toggleMenu(false);
			}
		});
	});
}